import { sentimentTopics, hotKeywords } from "@/mocks/hotTopics";

export default function SentimentPulse() {
  return (
    <section id="pulse" className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              舆论风向 · 温度计
            </p>
            <h4 className="flex items-center gap-3 font-serif text-2xl font-black text-foreground-950 md:text-3xl">
              <a href="#pulse" className="flex items-center gap-3">
                风向正在偏向哪边
              </a>
            </h4>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-foreground-500">
            把每一派的支持比例摊开来看，争议焦点到底站得住几成。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.5fr_1fr]">
          {/* 支持/反对/观望比例 */}
          <div className="rounded-xl border border-background-200 bg-background-100/40 p-5 md:p-6">
            <div className="flex flex-col gap-5">
              {sentimentTopics.map((s) => (
                <div key={s.topic}>
                  <div className="mb-2 flex items-center justify-between">
                    <p className="text-sm font-semibold text-foreground-900">{s.topic}</p>
                    <span className="text-xs text-foreground-400">{s.note}</span>
                  </div>
                  {/* 三色堆叠条 */}
                  <div className="flex h-3 w-full overflow-hidden rounded-full bg-background-200">
                    {s.support > 0 && (
                      <div className="h-full bg-primary-500" style={{ width: `${s.support}%` }} />
                    )}
                    {s.oppose > 0 && (
                      <div className="h-full bg-secondary-500" style={{ width: `${s.oppose}%` }} />
                    )}
                    {s.neutral > 0 && (
                      <div className="h-full bg-foreground-300" style={{ width: `${s.neutral}%` }} />
                    )}
                  </div>
                  <div className="mt-2 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-foreground-600">
                    <span className="flex items-center gap-1.5">
                      <span className="h-2 w-2 rounded-sm bg-primary-500" /> 支持方 {s.support}%
                    </span>
                    <span className="flex items-center gap-1.5">
                      <span className="h-2 w-2 rounded-sm bg-secondary-500" /> 反对方 {s.oppose}%
                    </span>
                    {s.neutral > 0 && (
                      <span className="flex items-center gap-1.5">
                        <span className="h-2 w-2 rounded-sm bg-foreground-300" /> 观望 {s.neutral}%
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 热议关键词 */}
          <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="mb-4 flex items-center justify-between">
              <h5 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                <i className="ri-hashtag text-primary-500" />
                热议关键词
              </h5>
              <span className="flex items-center gap-1 text-xs text-accent-700">
                <i className="ri-fire-fill" />
                讨论热力
              </span>
            </div>
            <div className="flex flex-col gap-3">
              {hotKeywords.map((k) => (
                <div key={k.word} className="flex items-center gap-3">
                  <span className="w-24 shrink-0 truncate text-sm text-foreground-700">{k.word}</span>
                  <div className="h-2 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-gradient-to-r from-accent-400 to-primary-500" style={{ width: `${k.heat}%` }} />
                  </div>
                  <span className="w-8 shrink-0 text-right text-xs text-foreground-400">{k.heat}</span>
                </div>
              ))}
            </div>
            <p className="mt-4 border-t border-background-200 pt-3 text-xs leading-relaxed text-foreground-400">
              关键词仅展示网友当下讨论中反复出现的高频表达，用于快速感知风向。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}